import React from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <div className='foot'>
      <footer>
        <div class="footer-content">
            <div class="footer-logo">
                {/* <img src="logo.png" alt="Your App Logo"> */}
            </div>
            <div class="footer-links">
                <ul>
                    <li><Link to='/'>Made with ☕ &  ❤️</Link></li>
                </ul>
            </div>
        </div>
    </footer>
    </div>
  )
}

export default Footer;
